/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
};

export type EssayResultType = {
  __typename?: 'EssayResultType';
  chatIdHash?: Maybe<Scalars['String']>;
  essayText?: Maybe<Scalars['String']>;
  responseGenIdHash?: Maybe<Scalars['String']>;
  status: StatusType;
};

export type FileInstructionInput = {
  content: Scalars['String'];
  filename: Scalars['String'];
};

export type FunnelAiDetectorType = {
  __typename?: 'FunnelAiDetectorType';
  aiDetectBySentenceData?: Maybe<Scalars['String']>;
  genRequestId?: Maybe<Scalars['Int']>;
  status: StatusType;
  title?: Maybe<Scalars['String']>;
};

export type FunnelAiHumanizerType = {
  __typename?: 'FunnelAiHumanizerType';
  humanizedText?: Maybe<Scalars['String']>;
  status: StatusType;
  title?: Maybe<Scalars['String']>;
};

export type FunnelParaphraserSlimType = {
  __typename?: 'FunnelParaphraserSlimType';
  paraphrasedText?: Maybe<Scalars['String']>;
  status: StatusType;
  title?: Maybe<Scalars['String']>;
};

export type GenerateTitleResultType = {
  __typename?: 'GenerateTitleResultType';
  status: StatusType;
  title?: Maybe<Scalars['String']>;
};

export type HomeworkResultFirstType = {
  __typename?: 'HomeworkResultFirstType';
  chatIdHash?: Maybe<Scalars['String']>;
  generatedText?: Maybe<Scalars['String']>;
  responseGenIdHash?: Maybe<Scalars['String']>;
  status: StatusType;
  textSubjectGroup?: Maybe<Scalars['String']>;
};

export type HomeworkResultNextType = {
  __typename?: 'HomeworkResultNextType';
  generatedText?: Maybe<Scalars['String']>;
  responseGenIdHash?: Maybe<Scalars['String']>;
  status: StatusType;
};

export type Mutation = {
  __typename?: 'Mutation';
  brainToolsHomeworkHelperFirst: HomeworkResultFirstType;
  brainToolsHomeworkHelperGenerateTitle: GenerateTitleResultType;
  brainToolsHomeworkHelperNext: HomeworkResultNextType;
  funnelAiDetector: FunnelAiDetectorType;
  funnelAiHumanizer: FunnelAiHumanizerType;
  funnelParaphraserSlim: FunnelParaphraserSlimType;
  generateEssay: EssayResultType;
  runDeleteSavedTextBack: StatusType;
  runSaveTextBack: SaveTextType;
  trackJsError: StatusType;
};


export type MutationBrainToolsHomeworkHelperFirstArgs = {
  clientHash: Scalars['String'];
  clientUserId?: InputMaybe<Scalars['String']>;
  gaCid?: InputMaybe<Scalars['String']>;
  instructions?: InputMaybe<Scalars['String']>;
  instructionsFromFiles?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  requestType: Scalars['String'];
  sessionSourceUrl?: InputMaybe<Scalars['String']>;
  subject?: InputMaybe<Scalars['String']>;
};


export type MutationBrainToolsHomeworkHelperGenerateTitleArgs = {
  clientHash: Scalars['String'];
  instructions?: InputMaybe<Scalars['String']>;
  instructionsFromFiles?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type MutationBrainToolsHomeworkHelperNextArgs = {
  chatIdHash: Scalars['String'];
  clientHash: Scalars['String'];
  instructions: Scalars['String'];
};


export type MutationFunnelAiDetectorArgs = {
  clientHash: Scalars['String'];
  clientUserId?: InputMaybe<Scalars['String']>;
  fileIdHashes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  gaCid?: InputMaybe<Scalars['String']>;
  instructions: Scalars['String'];
  sessionSourceUrl?: InputMaybe<Scalars['String']>;
  withSignals?: InputMaybe<Scalars['Int']>;
};


export type MutationFunnelAiHumanizerArgs = {
  clientHash: Scalars['String'];
  clientUserId?: InputMaybe<Scalars['String']>;
  fileIdHashes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  gaCid?: InputMaybe<Scalars['String']>;
  instructions: Scalars['String'];
  sessionSourceUrl?: InputMaybe<Scalars['String']>;
};


export type MutationFunnelParaphraserSlimArgs = {
  clientHash: Scalars['String'];
  instructions: Scalars['String'];
};


export type MutationGenerateEssayArgs = {
  clientHash: Scalars['String'];
  clientUserId: Scalars['String'];
  fileIdHashes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  formattingStyle?: InputMaybe<Scalars['String']>;
  gaCid?: InputMaybe<Scalars['String']>;
  instructions?: InputMaybe<Scalars['String']>;
  instructionsFromFiles?: InputMaybe<Array<InputMaybe<FileInstructionInput>>>;
  pageCount?: InputMaybe<Scalars['Int']>;
  sessionSourceUrl?: InputMaybe<Scalars['String']>;
  subject?: InputMaybe<Scalars['String']>;
  topic?: InputMaybe<Scalars['String']>;
};


export type MutationRunDeleteSavedTextBackArgs = {
  toolDocumentIdHash: Scalars['String'];
};


export type MutationRunSaveTextBackArgs = {
  genResponseIdHash: Scalars['String'];
};


export type MutationTrackJsErrorArgs = {
  message: Array<Scalars['String']>;
  subject: Scalars['String'];
};

export type Query = {
  __typename?: 'Query';
  savedTextGroup: SavedTextGroup;
  textCategoryGroup: TextCategoryGroup;
};

export type SaveTextType = {
  __typename?: 'SaveTextType';
  status: StatusType;
  toolDocumentIdHash?: Maybe<Scalars['String']>;
};

export type SavedTextGroup = {
  __typename?: 'SavedTextGroup';
  getSavedTextListBack: ToolDocumentListType;
  getSavedTextOneBack: ToolDocumentOneType;
};


export type SavedTextGroupGetSavedTextListBackArgs = {
  clientHash: Scalars['String'];
  clientUserId: Scalars['String'];
};


export type SavedTextGroupGetSavedTextOneBackArgs = {
  toolDocumentIdHash: Scalars['String'];
};

/** This type is used to represent response status of specific type (not found, unauthorized, ...) */
export type StatusType = {
  __typename?: 'StatusType';
  /** Response code (like HTTP response code, but for specific field) */
  code: Scalars['Int'];
  /** Human readable message (not recommended to use in code) */
  message: Scalars['String'];
};

export type TextCategoryGroup = {
  __typename?: 'TextCategoryGroup';
  getPostPurchaseTextCategoryBack: TextCategoryType;
  getPrePurchaseTextCategoryBack: TextCategoryType;
};


export type TextCategoryGroupGetPostPurchaseTextCategoryBackArgs = {
  clientHash: Scalars['String'];
  clientUserId: Scalars['Int'];
};


export type TextCategoryGroupGetPrePurchaseTextCategoryBackArgs = {
  clientHash: Scalars['String'];
  gaCid: Scalars['String'];
};

export type TextCategoryType = {
  __typename?: 'TextCategoryType';
  status: StatusType;
  textCategory?: Maybe<Scalars['String']>;
};

export type ToolDocumentListType = {
  __typename?: 'ToolDocumentListType';
  status: StatusType;
  toolDocuments?: Maybe<Scalars['String']>;
};

export type ToolDocumentOneType = {
  __typename?: 'ToolDocumentOneType';
  status: StatusType;
  toolDocumentData?: Maybe<Scalars['String']>;
};

export type BrainToolsHomeworkHelperFirstMutationVariables = Exact<{
  clientHash: Scalars['String'];
  clientUserId: Scalars['String'];
  sessionSourceUrl: Scalars['String'];
  gaCid: Scalars['String'];
  requestType: Scalars['String'];
  subject?: InputMaybe<Scalars['String']>;
  instructions: Scalars['String'];
  instructionsFromFiles?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
}>;


export type BrainToolsHomeworkHelperFirstMutation = { __typename?: 'Mutation', brainToolsHomeworkHelperFirst: { __typename?: 'HomeworkResultFirstType', generatedText?: string | null, responseGenIdHash?: string | null, chatIdHash?: string | null, textSubjectGroup?: string | null, status: { __typename?: 'StatusType', code: number, message: string } } };

export type BrainToolsHomeworkHelperNextMutationVariables = Exact<{
  clientHash: Scalars['String'];
  chatIdHash: Scalars['String'];
  instructions: Scalars['String'];
}>;


export type BrainToolsHomeworkHelperNextMutation = { __typename?: 'Mutation', brainToolsHomeworkHelperNext: { __typename?: 'HomeworkResultNextType', generatedText?: string | null, responseGenIdHash?: string | null, status: { __typename?: 'StatusType', code: number, message: string } } };

export type BrainToolsHomeworkHelperGenerateTitleMutationVariables = Exact<{
  clientHash: Scalars['String'];
  instructions?: InputMaybe<Scalars['String']>;
  instructionsFromFiles?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
}>;


export type BrainToolsHomeworkHelperGenerateTitleMutation = { __typename?: 'Mutation', brainToolsHomeworkHelperGenerateTitle: { __typename?: 'GenerateTitleResultType', title?: string | null, status: { __typename?: 'StatusType', code: number, message: string } } };


export const BrainToolsHomeworkHelperFirstDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"BrainToolsHomeworkHelperFirst"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"clientHash"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"clientUserId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sessionSourceUrl"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"gaCid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"requestType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"subject"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"instructions"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"instructionsFromFiles"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brainToolsHomeworkHelperFirst"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"clientHash"},"value":{"kind":"Variable","name":{"kind":"Name","value":"clientHash"}}},{"kind":"Argument","name":{"kind":"Name","value":"clientUserId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"clientUserId"}}},{"kind":"Argument","name":{"kind":"Name","value":"sessionSourceUrl"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sessionSourceUrl"}}},{"kind":"Argument","name":{"kind":"Name","value":"gaCid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"gaCid"}}},{"kind":"Argument","name":{"kind":"Name","value":"requestType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"requestType"}}},{"kind":"Argument","name":{"kind":"Name","value":"subject"},"value":{"kind":"Variable","name":{"kind":"Name","value":"subject"}}},{"kind":"Argument","name":{"kind":"Name","value":"instructions"},"value":{"kind":"Variable","name":{"kind":"Name","value":"instructions"}}},{"kind":"Argument","name":{"kind":"Name","value":"instructionsFromFiles"},"value":{"kind":"Variable","name":{"kind":"Name","value":"instructionsFromFiles"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"generatedText"}},{"kind":"Field","name":{"kind":"Name","value":"responseGenIdHash"}},{"kind":"Field","name":{"kind":"Name","value":"chatIdHash"}},{"kind":"Field","name":{"kind":"Name","value":"textSubjectGroup"}}]}}]}}]} as unknown as DocumentNode<BrainToolsHomeworkHelperFirstMutation, BrainToolsHomeworkHelperFirstMutationVariables>;
export const BrainToolsHomeworkHelperNextDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"BrainToolsHomeworkHelperNext"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"clientHash"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"chatIdHash"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"instructions"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brainToolsHomeworkHelperNext"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"clientHash"},"value":{"kind":"Variable","name":{"kind":"Name","value":"clientHash"}}},{"kind":"Argument","name":{"kind":"Name","value":"chatIdHash"},"value":{"kind":"Variable","name":{"kind":"Name","value":"chatIdHash"}}},{"kind":"Argument","name":{"kind":"Name","value":"instructions"},"value":{"kind":"Variable","name":{"kind":"Name","value":"instructions"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"generatedText"}},{"kind":"Field","name":{"kind":"Name","value":"responseGenIdHash"}}]}}]}}]} as unknown as DocumentNode<BrainToolsHomeworkHelperNextMutation, BrainToolsHomeworkHelperNextMutationVariables>;
export const BrainToolsHomeworkHelperGenerateTitleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"BrainToolsHomeworkHelperGenerateTitle"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"clientHash"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"instructions"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"instructionsFromFiles"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brainToolsHomeworkHelperGenerateTitle"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"clientHash"},"value":{"kind":"Variable","name":{"kind":"Name","value":"clientHash"}}},{"kind":"Argument","name":{"kind":"Name","value":"instructions"},"value":{"kind":"Variable","name":{"kind":"Name","value":"instructions"}}},{"kind":"Argument","name":{"kind":"Name","value":"instructionsFromFiles"},"value":{"kind":"Variable","name":{"kind":"Name","value":"instructionsFromFiles"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]} as unknown as DocumentNode<BrainToolsHomeworkHelperGenerateTitleMutation, BrainToolsHomeworkHelperGenerateTitleMutationVariables>;